import React, { useEffect, useState } from 'react';

const STOCK_GAME_AD_BASE_URL = 'https://adops.bt.dk/stockgame';

export const getStockGameBannerUrl = (placement, device) => {
    return `${STOCK_GAME_AD_BASE_URL}/${placement}/${device}/index.html`;
};

const isMobileViewport = () => {
    return typeof window !== 'undefined' && window.innerWidth < 768;
};

export const SponsorBanner = ({
    mode = 'image', // "image" or "iframe"
    image,
    url,
    alt = 'Sponsor Banner',
    css_classes = 'd-flex justify-content-center align-items-center pb-4 pt-4',
    iframeDesktopUrl,
    iframeMobileUrl,
    sponsorName = 'sponsor',
    placement,
}) => {
    const hasPlacement = placement !== undefined && placement !== null;
    const isIframeMode = mode === 'iframe' || hasPlacement;
    const [isMobile, setIsMobile] = useState(isMobileViewport);

    const desktopUrl = hasPlacement
        ? getStockGameBannerUrl(placement, 'desktop')
        : iframeDesktopUrl;
    const mobileUrl = hasPlacement
        ? getStockGameBannerUrl(placement, 'mobile')
        : iframeMobileUrl;
    const bannerName = hasPlacement
        ? `AD_LEADERBOARD_${placement}`
        : sponsorName;

    useEffect(() => {
        if (!isIframeMode || typeof window === 'undefined') return undefined;

        const updateViewport = () => setIsMobile(isMobileViewport());
        updateViewport();
        window.addEventListener('resize', updateViewport);

        return () => window.removeEventListener('resize', updateViewport);
    }, [isIframeMode]);

    if (isIframeMode) {
        const wrapperStyle = {
            position: 'relative',
            background: 'transparent',
            margin: '0 auto',
            width: isMobile ? '320px' : '100%',
            maxWidth: isMobile ? '100%' : '930px',
            aspectRatio: isMobile ? '1 / 1' : '31 / 6',
        };

        const iframeStyle = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            border: 'none',
            top: 0,
            left: 0,
        };

        return (
            <div
                className="d-flex justify-content-center align-items-center w-100 my-4"
                data-banner-placement={hasPlacement ? placement : undefined}
            >
                <div style={wrapperStyle}>
                    <iframe
                        src={isMobile ? mobileUrl : desktopUrl}
                        style={iframeStyle}
                        title={bannerName}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={css_classes}>
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="ad_sponsor_banner_link"
            >
                <img
                    src={image}
                    alt={alt}
                    className="ad_sponsor_banner_image"
                    style={{ maxWidth: '100%', height: 'auto' }}
                />
            </a>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/c/SponsorBanner.js